import type { ColDef, GridApi } from "@ag-grid-community/core";
import type { FacetTableData } from "./facet-table-helpers";

export const FACET_RESULT_TABLE_DEFAULT_COL_DEF: ColDef = {
    sortable: true,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    flex: 1,
    minWidth: 120,
    valueFormatter: ({ value }) => String(value ?? ""),
};

export function buildFacetResultTableColDefs(headers: string[], isEditing: boolean): ColDef[] {
    return headers.map((header, idx) => ({
        field: header,
        rowDrag: !isEditing && idx === 0,
        editable: isEditing,
        headerName: header.trim() || `Column ${idx + 1}`,
    }));
}

export function cloneFacetTableRows(rows: Record<string, unknown>[]): Record<string, unknown>[] {
    return rows.map((row) => ({ ...row }));
}

export function collectFacetTableFromGrid(api: GridApi, headers: string[]): FacetTableData {
    const rows: Record<string, unknown>[] = [];
    api.forEachNode((node) => {
        if (node.data) rows.push({ ...node.data });
    });
    return { headers, rows };
}

type BatchGridApi = GridApi & {
    startBatchEdit?: () => void;
    commitBatchEdit?: () => void;
    cancelBatchEdit?: () => void;
};

export function startFacetTableBatchEdit(api: GridApi): void {
    (api as BatchGridApi).startBatchEdit?.();
}

export function commitFacetTableBatchEdit(api: GridApi): void {
    api.stopEditing();
    (api as BatchGridApi).commitBatchEdit?.();
}

export function cancelFacetTableBatchEdit(api: GridApi, snapshotRows: Record<string, unknown>[]): void {
    api.stopEditing(true);
    const batchApi = api as BatchGridApi;
    if (batchApi.cancelBatchEdit) {
        batchApi.cancelBatchEdit();
        return;
    }
    api.setGridOption("rowData", cloneFacetTableRows(snapshotRows));
}
